import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import ProductPrice from '../../ui-library/ProductPrice';

import theme from '../../ui-library/theme';
import { Cabbage, Earth, Mango, Neptune } from '../../ui-library/typography';
import { Button } from '../../ui-library/buttons';
import { Space } from '../../ui-library/space';
import useNavigation from '../../utils/useNavigation';
import { trackProductButtonClick } from '../tracking/discovery.tracking';

const StyledDiv = styled.div`
  width: 100%;
  height: 100%;
  min-height: 370px;
  background-color: #faf7e2;
  overflow: hidden;
  border-radius: ${(props) => props.borderRadius || 0};
`;

const StyledImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;

  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  z-index: -10;

  :hover {
    -moz-transform: scale(1.1);
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
`;
const StyledGradient = styled.div`
  pointer-events: none;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 254, 244, 0) 75%,
    rgba(255, 254, 244, 0.8) 75%,
    rgba(255, 254, 244, 0.8) 100%
  );
  position: absolute;
  left: 0;
  top: 0;
`;
const StyledTextWrapper = styled.div`
  position: absolute;
  left: 32px;
  bottom: 28px;
  pointer-events: none;
`;

const getNameToShow = (name) => {
  if (!name) return '';
  if (name.length < 26) return name;
  return name.substring(0, 26) + '...';
};

const FabricCard = ({
  product: { url, imageURL, heading, name, price, description, categoryName },
  borderRadius,
  showTitle = true,
}) => {
  const { goToURL } = useNavigation();
  const trackClick = () => {
    trackProductButtonClick(categoryName, heading);
  };
  const handleClick = () => {
    trackClick();
    goToURL(url);
  };
  return (
    <StyledDiv borderRadius={borderRadius}>
      <Link to={url} onClick={trackClick}>
        <StyledImage src={imageURL} />

        {showTitle && (
          <>
            <StyledGradient />
            <StyledTextWrapper>
              <Neptune marginBottom='2px' color={theme.colors.secondary.dark}>
                {getNameToShow(name)}
              </Neptune>
            </StyledTextWrapper>
          </>
        )}
      </Link>
    </StyledDiv>
  );
};

export default FabricCard;
